import React from 'react';
import { ILLUSTRATIONS } from '../../Constants/Images.constants';
import { getRandomInt } from '../../Helpers/Math.helpers';
import Illustration from './Illustration.component';

type RandomIllustrationProps = {
  availableIllustrations?: string[];
};

const RandomIllustration = ({
  availableIllustrations = Object.keys(ILLUSTRATIONS),
}: RandomIllustrationProps) => {
  const numberOfIllustrations = availableIllustrations.length - 1;
  const randomId = getRandomInt(0, numberOfIllustrations);
  const selectedIllustration = availableIllustrations[randomId];
  return (
    <>
      <Illustration svg={ILLUSTRATIONS[selectedIllustration]} />
    </>
  );
};

export default RandomIllustration;
